export default __webpack_public_path__ + "static/red_frog_center-ae134e55b7969d21c83a594cb40995d4.png";